export enum InsurancePackage {
    cascoMtplInvalid = 'casco-mtpl-invalid',
    cascoInvalidMtplValidLongTerm = 'casco-invalid-mtpl-valid-long-term',
    mtplInvalidCascoValidLongTerm = 'mtpl-invalid-casco-valid-long-term',
    mtplValidExpiringSoonCascoInvalid = 'mtpl-valid-expiring-soon-casco-invalid',
    cascoValidExpiringSoonMtplInvalid = 'casco-valid-expiring-soon-mtpl-invalid',
    bothValidCascoExpiringSoon = 'both-valid-casco-expiring-soon',
    bothValidMtplExpiringSoon = 'both-valid-mtpl-expiring-soon',
    cascoMtplValidLongTerm = 'casco-mtpl-valid-long-term',
    cascoMtplValidExpiringSoon = 'casco-mtpl-valid-expiring-soon',
    noPremiumsAvailable = 'no-premiums-available',
}
